import classNames from 'classnames/bind';
import styles from './MultiSelectMenu.module.css';

const cx = classNames.bind(styles);

const MultiSelectMenu = (other) => <ul {...other} className={cx('menu')} />;

export default MultiSelectMenu;
